import { IComboObject } from "../../../../../domain/editableFormat/objects";
import { IComboObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { SelectableObjectTranslator } from "./base";
import { ComboSelectBehaviorTranslator, QuestionnaireTranslator, RelationReplacer } from "./properties";

export class ComboObjectTranslator extends AbstractObjectTranslator<IComboObject, IComboObjectBean> {
  constructor() {
    super(new SelectableObjectTranslator());
  }

  protected shouldRecordName(source: IComboObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IComboObject, bean: IComboObjectBean, formatId: number): void {
    // @send-externalは対応しない.(既にリプレース済のT島大LISでしか利用されてない.)
    source.comboSelectBehavior = this.comboSelectBehavior.from(bean);
    source.questionnaire = this.questionnaire.from(bean);
  }

  overwriteBean(source: IComboObjectBean, object: IComboObject): void {
    // @send-externalは対応しない.(既にリプレース済のT島大LISでしか利用されてない.)
    const comboSelectBehavior = this.comboSelectBehavior.to(object.comboSelectBehavior);
    source["@code"] = comboSelectBehavior.code;
    source.comboitem = comboSelectBehavior.comboitem;
    this.relationReplacer.replaceBeans(source, "questionnaire", this.questionnaire.to(object));
    this.relationReplacer.replaceBeans(source, "questionnaire-children", this.questionnaire.toChildren(object));
  }

  private readonly comboSelectBehavior = new ComboSelectBehaviorTranslator();
  private readonly questionnaire = new QuestionnaireTranslator();
  private readonly relationReplacer = new RelationReplacer();
}
